<template>
    <header class="h-14 flex items-center justify-between px-4 border-b border-surface-200 dark:border-surface-700 bg-surface-0 dark:bg-surface-900 shrink-0 lg:hidden">
        <button class="p-2 rounded-lg hover:bg-surface-100 dark:hover:bg-surface-800" @click="toggleMobileMenu">
            <i class="pi pi-bars text-xl" />
        </button>
        <span class="font-semibold text-lg">NomNom</span>
        <span />
    </header>
</template>

<script lang="ts" setup>
    import { inject } from 'vue'

    const toggleMobileMenu = inject<() => void>('toggleMobileMenu', () => {})
</script>
